import { useEffect, useMemo, useState } from "react";
import { FiImage } from "react-icons/fi";

interface MediaSelectionPreviewProps {
  imageUrl?: string | null;
  name: string;
  className?: string;
}

export const MEDIA_PREVIEW_FALLBACK_COLORS = [
  { background: "#F6AFAF", color: "#911919" },
  { background: "#FDE6B4", color: "#8A5300" },
  { background: "#CBE8FF", color: "#155B9C" },
  { background: "#D5F5E3", color: "#166534" },
  { background: "#E6DCFF", color: "#5B21B6" },
  { background: "#FCE3F0", color: "#9D174D" },
];

export const getMediaPreviewColors = (name: string) => {
  let hash = 0;

  for (let index = 0; index < name.length; index += 1) {
    hash = (hash * 31 + name.charCodeAt(index)) >>> 0;
  }

  return MEDIA_PREVIEW_FALLBACK_COLORS[
    hash % MEDIA_PREVIEW_FALLBACK_COLORS.length
  ];
};

const MediaSelectionPreview = ({
  imageUrl,
  name,
  className = "",
}: MediaSelectionPreviewProps) => {
  const [hasImageError, setHasImageError] = useState(false);

  useEffect(() => {
    setHasImageError(false);
  }, [imageUrl]);

  const fallbackColors = useMemo(() => getMediaPreviewColors(name || ""), [name]);
  const shouldShowImage = !!imageUrl && !hasImageError;

  if (shouldShowImage) {
    return (
      <div className={`media-selection-preview image ${className}`.trim()}>
        <img
          src={imageUrl || ""}
          alt={name || "Selected media"}
          onError={() => setHasImageError(true)}
        />
      </div>
    );
  }

  return (
    <div
      className={`media-selection-preview fallback ${className}`.trim()}
      style={{
        backgroundColor: fallbackColors.background,
        color: fallbackColors.color,
      }}
      aria-hidden="true"
    >
      <FiImage size={28} strokeWidth={2.6} />
    </div>
  );
};

export default MediaSelectionPreview;
